import { render, staticRenderFns } from "./SupplierDetails.vue?vue&type=template&id=db611822&scoped=true"
import script from "./SupplierDetails.vue?vue&type=script&lang=js"
export * from "./SupplierDetails.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetails.vue?vue&type=style&index=0&id=db611822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db611822",
  null
  
)

export default component.exports